import {useEffect, useState} from 'react';

import {getServerUptimeSeconds} from 'features/server/lib/serverRowView';

export const useServerUptime = (
    uptimeSeconds: number | null,
    metricsTs: number | null,
    isLive: boolean,
): number | null => {
    const [nowSeconds, setNowSeconds] = useState(() => Math.floor(Date.now() / 1000));

    useEffect(() => {
        if (!isLive) {
            return;
        }

        const timer = setInterval(() => setNowSeconds(Math.floor(Date.now() / 1000)), 1000);

        return () => clearInterval(timer);
    }, [isLive]);

    return getServerUptimeSeconds(uptimeSeconds, isLive, metricsTs, nowSeconds);
};

export default useServerUptime;
